import { Link } from 'react-router-dom';
import Logo from './Logo.jsx';
import { footerColumns } from '../constants/navigation.js';
import { school } from '../constants/school.js';

export default function Footer() {
  return (
    <footer className="bg-forest-deep pb-[34px] pt-14 text-sage">
      <div className="mx-auto grid max-w-[1240px] gap-[34px] px-5 sm:grid-cols-2 sm:px-8 lg:grid-cols-[1.4fr_1fr_1fr_1fr]">
        <div>
          <Logo tone="dark" />
          <p className="mt-4 max-w-[300px] text-[14.5px] leading-[1.6]">
            {school.address}
            <br />
            {school.hours}
            <br />
            <a
              href={`tel:${school.phone.replace(/\s/g, '')}`}
              className="text-sage hover:text-sun"
            >
              {school.phone}
            </a>{' '}
            ·{' '}
            <a href={`mailto:${school.email}`} className="text-sage hover:text-sun">
              {school.email}
            </a>
          </p>
        </div>

        {footerColumns.map((column) => (
          <nav key={column.heading} aria-label={column.heading}>
            <h2 className="font-display text-base font-bold text-cream">
              {column.heading}
            </h2>
            <ul className="mt-3 flex flex-col gap-[9px] text-[14.5px]">
              {column.links.map((link) => (
                <li key={link.label}>
                  <Link to={link.to} className="text-sage hover:text-sun">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        ))}
      </div>

      <div className="mx-auto mt-[34px] flex max-w-[1240px] flex-wrap justify-between gap-4 border-t border-sage/20 px-5 pt-6 text-[13.5px] sm:px-8">
        <span>© 2026 Toddler's Academy. A state-funded school.</span>
        <span className="flex flex-wrap gap-x-2">
          {/* The privacy notice is a real page: the enquiry form collects a
              child's name and date of birth, so it cannot be a dead label. */}
          <Link to="/privacy" className="text-sage underline hover:text-sun">
            Privacy
          </Link>
          <span aria-hidden="true">·</span>
          <Link to="/staff/login" className="text-sage hover:text-sun">
            Staff sign in
          </Link>
        </span>
      </div>
    </footer>
  );
}
